// K6 — FormFill `numeric` sorusunda önceki yıla göre olağan dışı değer kararı.
// Karar saf fonksiyonda (`outlierNoticeText`), hook yalnız memo sarmalayıcısı —
// FormFill.tsx'e satır içi mantık eklenmez.

import { useMemo } from "react";
import {
  formatOutlierRatio,
  formatReportingPeriod,
  outlierRatio,
  type PriorYearEntry,
  type QuestionSnapshot,
} from "@mahir/shared";
import { OUTLIER_COPY } from "../lib/outlier-copy";

export function outlierNoticeText(
  questionType: QuestionSnapshot["type"],
  priorEntry: PriorYearEntry | undefined,
  value: unknown,
): string | null {
  if (questionType !== "numeric" || priorEntry?.questionType !== "numeric") return null;
  const prior = priorEntry.value;
  if (typeof prior !== "number" || typeof value !== "number") return null;
  const ratio = outlierRatio(value, prior);
  if (ratio === null) return null;
  const period = formatReportingPeriod(priorEntry.reportingYear, priorEntry.periodType, {
    short: true,
  });
  return OUTLIER_COPY.form(period, prior, value, formatOutlierRatio(ratio));
}

export function useOutlierNotice(
  questionType: QuestionSnapshot["type"],
  priorEntry: PriorYearEntry | undefined,
  value: unknown,
): string | null {
  return useMemo(
    () => outlierNoticeText(questionType, priorEntry, value),
    [questionType, priorEntry, value],
  );
}
